import type { Database } from '@pazportal/supabase';

export type SolutionType = Database['public']['Enums']['solution_type'];
export type IntelPriority = Database['public']['Enums']['site_intel_priority'];

/** Mirrors the Postgres enum; order matches SOLUTION_TYPE_ORDER in formatters. */
export const SOLUTION_TYPES: SolutionType[] = [
  'managed_network',
  'video_surveillance',
  'access_control',
  'pro_av',
  'digital_signage',
  'security_alarm',
  'smart_robotics',
  'keytracer',
  'it_cloud',
  'pos_systems',
  'conferencing',
  'audio',
];

export const INTEL_PRIORITIES: { value: IntelPriority; label: string }[] = [
  { value: 'urgent', label: 'Urgent' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];

export const INTEL_TAGS = [
  'switch_refresh',
  'maintenance_contract',
  'access_control',
  'camera_expansion',
  'signage_upgrade',
  'pos_replacement',
  'av_upgrade',
];

export const INTEL_MIN_CHARS = 20;
